<pvd-header hide-login="true"></pvd-header>

<div class="pvd-container-fluid container-divider">
  <h1 class="pvd-heading-XXL">Error</h1>
</div>

<div class="pvd-container-fluid container-divider">
  <p>{{errorMessage}}</p>
</div>
